import gql from 'graphql-tag'

export default gql`
  query getContactInfo($id: String!) {
    getExpert(id: $id) {
      id
      address {
        id
        address1
        address2
        zipCode
        region
        city
      }
      personalSummary {
        id
        paroReferrer
      }
      onboardingStep
    }
  }
`
